import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c00110c = () => interopDefault(import('../pages/delivery-guide/index.vue' /* webpackChunkName: "pages/delivery-guide/index" */))
const _5449dfba = () => interopDefault(import('../pages/drop-off/index.vue' /* webpackChunkName: "pages/drop-off/index" */))
const _1f5244ba = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _4940d5ea = () => interopDefault(import('../pages/fullfillment-rate/index.vue' /* webpackChunkName: "pages/fullfillment-rate/index" */))
const _7c7b8e94 = () => interopDefault(import('../pages/grade-rights/index.vue' /* webpackChunkName: "pages/grade-rights/index" */))
const _cbb65874 = () => interopDefault(import('../pages/preview-picture/index.vue' /* webpackChunkName: "pages/preview-picture/index" */))
const _6fbe14e9 = () => interopDefault(import('../pages/activity/bid-application/index.vue' /* webpackChunkName: "pages/activity/bid-application/index" */))
const _d81e60ba = () => interopDefault(import('../pages/activity/demo-bid-application/index.vue' /* webpackChunkName: "pages/activity/demo-bid-application/index" */))
const _46ec5bb4 = () => interopDefault(import('../pages/activity/new-user-tasks/index.vue' /* webpackChunkName: "pages/activity/new-user-tasks/index" */))
const _5648f40a = () => interopDefault(import('../pages/activity/sign/index.vue' /* webpackChunkName: "pages/activity/sign/index" */))
const _241b4f57 = () => interopDefault(import('../pages/automatic-distribution/landing/index.vue' /* webpackChunkName: "pages/automatic-distribution/landing/index" */))
const _767abb5b = () => interopDefault(import('../pages/automatic-distribution/tip/index.vue' /* webpackChunkName: "pages/automatic-distribution/tip/index" */))
const _816a72ee = () => interopDefault(import('../pages/consignment/apply/index.vue' /* webpackChunkName: "pages/consignment/apply/index" */))
const _5b6010d2 = () => interopDefault(import('../pages/consignment/explain/index.vue' /* webpackChunkName: "pages/consignment/explain/index" */))
const _55db8ede = () => interopDefault(import('../pages/consignment/krTerminal/index.vue' /* webpackChunkName: "pages/consignment/krTerminal/index" */))
const _83488592 = () => interopDefault(import('../pages/consignment/pickUp/index.vue' /* webpackChunkName: "pages/consignment/pickUp/index" */))
const _2fd85055 = () => interopDefault(import('../pages/consignment/usTerminal/index.vue' /* webpackChunkName: "pages/consignment/usTerminal/index" */))
const _794d9783 = () => interopDefault(import('../pages/drop-off/api.ts' /* webpackChunkName: "pages/drop-off/api" */))
const _418a2918 = () => interopDefault(import('../pages/email/api.ts' /* webpackChunkName: "pages/email/api" */))
const _4bc7bd5a = () => interopDefault(import('../pages/email/apply-on/index.vue' /* webpackChunkName: "pages/email/apply-on/index" */))
const _6bc5b2d2 = () => interopDefault(import('../pages/email/deal-guide/index.vue' /* webpackChunkName: "pages/email/deal-guide/index" */))
const _57643ab5 = () => interopDefault(import('../pages/email/product-list.vue' /* webpackChunkName: "pages/email/product-list" */))
const _5295b20b = () => interopDefault(import('../pages/email/trackConfig.js' /* webpackChunkName: "pages/email/trackConfig" */))
const _666f18bc = () => interopDefault(import('../pages/email/welcome/index.vue' /* webpackChunkName: "pages/email/welcome/index" */))
const _32d2eb8c = () => interopDefault(import('../pages/faq/api.ts' /* webpackChunkName: "pages/faq/api" */))
const _9a503360 = () => interopDefault(import('../pages/faq/detail.vue' /* webpackChunkName: "pages/faq/detail" */))
const _18e5eec2 = () => interopDefault(import('../pages/faq/lang.js' /* webpackChunkName: "pages/faq/lang" */))
const _eb84a6d6 = () => interopDefault(import('../pages/faq/started/index.vue' /* webpackChunkName: "pages/faq/started/index" */))
const _04b5cf53 = () => interopDefault(import('../pages/fullfillment-rate/api.ts' /* webpackChunkName: "pages/fullfillment-rate/api" */))
const _341a46ea = () => interopDefault(import('../pages/fullfillment-rate/trackConfig.js' /* webpackChunkName: "pages/fullfillment-rate/trackConfig" */))
const _4f454094 = () => interopDefault(import('../pages/fullfillment-rate/types.ts' /* webpackChunkName: "pages/fullfillment-rate/types" */))
const _1827665a = () => interopDefault(import('../pages/help/api.ts' /* webpackChunkName: "pages/help/api" */))
const _009e7899 = () => interopDefault(import('../pages/help/category/index.vue' /* webpackChunkName: "pages/help/category/index" */))
const _696e825e = () => interopDefault(import('../pages/help/channel/index.vue' /* webpackChunkName: "pages/help/channel/index" */))
const _f27b2504 = () => interopDefault(import('../pages/help/constants.ts' /* webpackChunkName: "pages/help/constants" */))
const _4466efa8 = () => interopDefault(import('../pages/help/detail/index.vue' /* webpackChunkName: "pages/help/detail/index" */))
const _b24d567a = () => interopDefault(import('../pages/help/search/index.vue' /* webpackChunkName: "pages/help/search/index" */))
const _1e2cc016 = () => interopDefault(import('../pages/help/survey/index.vue' /* webpackChunkName: "pages/help/survey/index" */))
const _6e7bcb52 = () => interopDefault(import('../pages/identify/add-picture-example.vue' /* webpackChunkName: "pages/identify/add-picture-example" */))
const _714dfb87 = () => interopDefault(import('../pages/identify/app/index.vue' /* webpackChunkName: "pages/identify/app/index" */))
const _c9ee2326 = () => interopDefault(import('../pages/identify/app-detail/index.vue' /* webpackChunkName: "pages/identify/app-detail/index" */))
const _1872ac7d = () => interopDefault(import('../pages/identify/certificate/index.vue' /* webpackChunkName: "pages/identify/certificate/index" */))
const _42ddefe2 = () => interopDefault(import('../pages/identify/guide/index.vue' /* webpackChunkName: "pages/identify/guide/index" */))
const _a686a0e6 = () => interopDefault(import('../pages/identify/result/index.vue' /* webpackChunkName: "pages/identify/result/index" */))
const _498e4ddb = () => interopDefault(import('../pages/jockey/demo.vue' /* webpackChunkName: "pages/jockey/demo" */))
const _0eec7dd1 = () => interopDefault(import('../pages/newUser/clothes/index.vue' /* webpackChunkName: "pages/newUser/clothes/index" */))
const _7e21aff1 = () => interopDefault(import('../pages/newUser/shoes/index.vue' /* webpackChunkName: "pages/newUser/shoes/index" */))
const _285205d0 = () => interopDefault(import('../pages/newUser/watch/index.vue' /* webpackChunkName: "pages/newUser/watch/index" */))
const _30284864 = () => interopDefault(import('../pages/notice/seller-detail.vue' /* webpackChunkName: "pages/notice/seller-detail" */))
const _0aa3ad80 = () => interopDefault(import('../pages/other/api.ts' /* webpackChunkName: "pages/other/api" */))
const _0d5504ac = () => interopDefault(import('../pages/other/authentication-rules/index.vue' /* webpackChunkName: "pages/other/authentication-rules/index" */))
const _5bef7758 = () => interopDefault(import('../pages/other/conditions-of-use/index.vue' /* webpackChunkName: "pages/other/conditions-of-use/index" */))
const _c4ef1e58 = () => interopDefault(import('../pages/other/payment/index.vue' /* webpackChunkName: "pages/other/payment/index" */))
const _762102df = () => interopDefault(import('../pages/other/privacy-policy/index.vue' /* webpackChunkName: "pages/other/privacy-policy/index" */))
const _7a9b56e0 = () => interopDefault(import('../pages/other/protocol/index.vue' /* webpackChunkName: "pages/other/protocol/index" */))
const _2a0adf46 = () => interopDefault(import('../pages/other/supplementary/index.vue' /* webpackChunkName: "pages/other/supplementary/index" */))
const _50fca430 = () => interopDefault(import('../pages/other/user-protocol/index.vue' /* webpackChunkName: "pages/other/user-protocol/index" */))
const _55b8d1af = () => interopDefault(import('../pages/payment/result/index.vue' /* webpackChunkName: "pages/payment/result/index" */))
const _78e4ae78 = () => interopDefault(import('../pages/personal/bank/index.vue' /* webpackChunkName: "pages/personal/bank/index" */))
const _6ed3aa98 = () => interopDefault(import('../pages/personal/config.js' /* webpackChunkName: "pages/personal/config" */))
const _3a6437e4 = () => interopDefault(import('../pages/personal/mixins.js' /* webpackChunkName: "pages/personal/mixins" */))
const _59f35bee = () => interopDefault(import('../pages/personal/track-utils.js' /* webpackChunkName: "pages/personal/track-utils" */))
const _4225b2ea = () => interopDefault(import('../pages/personal/trackConfig.js' /* webpackChunkName: "pages/personal/trackConfig" */))
const _015e998a = () => interopDefault(import('../pages/product/info-correction/index.vue' /* webpackChunkName: "pages/product/info-correction/index" */))
const _595d58d2 = () => interopDefault(import('../pages/product/publicity/index.vue' /* webpackChunkName: "pages/product/publicity/index" */))
const _27b3e6bc = () => interopDefault(import('../pages/seller/preferential-rates/index.vue' /* webpackChunkName: "pages/seller/preferential-rates/index" */))
const _64a7c0cf = () => interopDefault(import('../pages/seller/preferential-rates-new/index.vue' /* webpackChunkName: "pages/seller/preferential-rates-new/index" */))
const _c219d6ce = () => interopDefault(import('../pages/seller/rule/index.vue' /* webpackChunkName: "pages/seller/rule/index" */))
const _2b534d30 = () => interopDefault(import('../pages/share/activity/index.vue' /* webpackChunkName: "pages/share/activity/index" */))
const _7c8bb45e = () => interopDefault(import('../pages/share/api.ts' /* webpackChunkName: "pages/share/api" */))
const _79e60f00 = () => interopDefault(import('../pages/share/components/index.js' /* webpackChunkName: "pages/share/components/index" */))
const _40230572 = () => interopDefault(import('../pages/share/download-app.vue' /* webpackChunkName: "pages/share/download-app" */))
const _6e9932c8 = () => interopDefault(import('../pages/share/product-detail/index.vue' /* webpackChunkName: "pages/share/product-detail/index" */))
const _b1c0adea = () => interopDefault(import('../pages/share/product-sales/index.vue' /* webpackChunkName: "pages/share/product-sales/index" */))
const _7038d239 = () => interopDefault(import('../pages/share/rate-activity/index.vue' /* webpackChunkName: "pages/share/rate-activity/index" */))
const _8f087078 = () => interopDefault(import('../pages/share/seller-initiate/index.vue' /* webpackChunkName: "pages/share/seller-initiate/index" */))
const _66129886 = () => interopDefault(import('../pages/share/seller-invited/index.vue' /* webpackChunkName: "pages/share/seller-invited/index" */))
const _45057d8c = () => interopDefault(import('../pages/share/venue/index.vue' /* webpackChunkName: "pages/share/venue/index" */))
const _fe1a78bc = () => interopDefault(import('../pages/activity/lottery-free/address/index.vue' /* webpackChunkName: "pages/activity/lottery-free/address/index" */))
const _f542f0de = () => interopDefault(import('../pages/activity/lottery-free/components/index.js' /* webpackChunkName: "pages/activity/lottery-free/components/index" */))
const _756282e7 = () => interopDefault(import('../pages/activity/lottery-free/current/index.vue' /* webpackChunkName: "pages/activity/lottery-free/current/index" */))
const _457fee39 = () => interopDefault(import('../pages/activity/lottery-free/detail/index.vue' /* webpackChunkName: "pages/activity/lottery-free/detail/index" */))
const _39d5dbfa = () => interopDefault(import('../pages/activity/lottery-free/past/index.vue' /* webpackChunkName: "pages/activity/lottery-free/past/index" */))
const _52bb80a7 = () => interopDefault(import('../pages/activity/lottery-free/share-detail/index.vue' /* webpackChunkName: "pages/activity/lottery-free/share-detail/index" */))
const _51581596 = () => interopDefault(import('../pages/activity/lottery-free/track-utils.js' /* webpackChunkName: "pages/activity/lottery-free/track-utils" */))
const _398a6c92 = () => interopDefault(import('../pages/activity/lottery-free/trackConfig.js' /* webpackChunkName: "pages/activity/lottery-free/trackConfig" */))
const _64ea88a8 = () => interopDefault(import('../pages/activity/new-user-tasks/track-utils.js' /* webpackChunkName: "pages/activity/new-user-tasks/track-utils" */))
const _4d1cdfa4 = () => interopDefault(import('../pages/activity/new-user-tasks/trackConfig.js' /* webpackChunkName: "pages/activity/new-user-tasks/trackConfig" */))
const _3d2f6533 = () => interopDefault(import('../pages/activity/sign/api.ts' /* webpackChunkName: "pages/activity/sign/api" */))
const _63281dde = () => interopDefault(import('../pages/activity/sign/components/index.vue' /* webpackChunkName: "pages/activity/sign/components/index" */))
const _db8fec4a = () => interopDefault(import('../pages/activity/sign/rewardRecord/index.vue' /* webpackChunkName: "pages/activity/sign/rewardRecord/index" */))
const _68292848 = () => interopDefault(import('../pages/activity/sign/track-utils.js' /* webpackChunkName: "pages/activity/sign/track-utils" */))
const _740ffcca = () => interopDefault(import('../pages/activity/sign/trackConfig.js' /* webpackChunkName: "pages/activity/sign/trackConfig" */))
const _45e3a99d = () => interopDefault(import('../pages/automatic-distribution/landing/trackConfig.js' /* webpackChunkName: "pages/automatic-distribution/landing/trackConfig" */))
const _2dc9bfce = () => interopDefault(import('../pages/automatic-distribution/tip/trackConfig.js' /* webpackChunkName: "pages/automatic-distribution/tip/trackConfig" */))
const _93ce3caa = () => interopDefault(import('../pages/consignment/apply/trackConfig.js' /* webpackChunkName: "pages/consignment/apply/trackConfig" */))
const _3cfb177f = () => interopDefault(import('../pages/consignment/explain/guide/index.vue' /* webpackChunkName: "pages/consignment/explain/guide/index" */))
const _20b674a2 = () => interopDefault(import('../pages/consignment/explain/rule/index.vue' /* webpackChunkName: "pages/consignment/explain/rule/index" */))
const _29def758 = () => interopDefault(import('../pages/email/welcome/trackConfig.js' /* webpackChunkName: "pages/email/welcome/trackConfig" */))
const _6d4584d2 = () => interopDefault(import('../pages/faq/components/collapse.vue' /* webpackChunkName: "pages/faq/components/collapse" */))
const _b0621f30 = () => interopDefault(import('../pages/faq/started/index-abord.vue' /* webpackChunkName: "pages/faq/started/index-abord" */))
const _e556995c = () => interopDefault(import('../pages/help/category/mock.ts' /* webpackChunkName: "pages/help/category/mock" */))
const _1b610c05 = () => interopDefault(import('../pages/help/category/types.ts' /* webpackChunkName: "pages/help/category/types" */))
const _1bc8a772 = () => interopDefault(import('../pages/help/config/surveyTrackConfig.ts' /* webpackChunkName: "pages/help/config/surveyTrackConfig" */))
const _24a4a430 = () => interopDefault(import('../pages/help/detail/trackConfig.js' /* webpackChunkName: "pages/help/detail/trackConfig" */))
const _0a6c27b1 = () => interopDefault(import('../pages/help/search/trackConfig.js' /* webpackChunkName: "pages/help/search/trackConfig" */))
const _d29b30fc = () => interopDefault(import('../pages/identify/app-detail/filter.js' /* webpackChunkName: "pages/identify/app-detail/filter" */))
const _63769437 = () => interopDefault(import('../pages/identify/certificate/trackConfig.js' /* webpackChunkName: "pages/identify/certificate/trackConfig" */))
const _8644b372 = () => interopDefault(import('../pages/identify/result/img.ts' /* webpackChunkName: "pages/identify/result/img" */))
const _2743fb27 = () => interopDefault(import('../pages/identify/result/trackConfig.js' /* webpackChunkName: "pages/identify/result/trackConfig" */))
const _0f2bb2dc = () => interopDefault(import('../pages/newUser/clothes/config.js' /* webpackChunkName: "pages/newUser/clothes/config" */))
const _4414d869 = () => interopDefault(import('../pages/newUser/components/imgBlock.vue' /* webpackChunkName: "pages/newUser/components/imgBlock" */))
const _7e60e4fc = () => interopDefault(import('../pages/newUser/shoes/config.js' /* webpackChunkName: "pages/newUser/shoes/config" */))
const _27d39bba = () => interopDefault(import('../pages/newUser/watch/config.js' /* webpackChunkName: "pages/newUser/watch/config" */))
const _9b05d306 = () => interopDefault(import('../pages/other/authentication-rules/lg-json.js' /* webpackChunkName: "pages/other/authentication-rules/lg-json" */))
const _1fb9b5da = () => interopDefault(import('../pages/other/conditions-of-use/lg-json.js' /* webpackChunkName: "pages/other/conditions-of-use/lg-json" */))
const _61bb9030 = () => interopDefault(import('../pages/other/privacy-policy/lg-json.js' /* webpackChunkName: "pages/other/privacy-policy/lg-json" */))
const _6e4532f2 = () => interopDefault(import('../pages/other/protocol/protocal-handle.js' /* webpackChunkName: "pages/other/protocol/protocal-handle" */))
const _8b86aa5c = () => interopDefault(import('../pages/payment/airwallex/api.ts' /* webpackChunkName: "pages/payment/airwallex/api" */))
const _b57b9530 = () => interopDefault(import('../pages/payment/airwallex/fastPay/index.vue' /* webpackChunkName: "pages/payment/airwallex/fastPay/index" */))
const _0843e0e4 = () => interopDefault(import('../pages/payment/airwallex/pay/index.vue' /* webpackChunkName: "pages/payment/airwallex/pay/index" */))
const _93784868 = () => interopDefault(import('../pages/payment/airwallex/util.ts' /* webpackChunkName: "pages/payment/airwallex/util" */))
const _16ec3f98 = () => interopDefault(import('../pages/personal/bank/account-admin/index.vue' /* webpackChunkName: "pages/personal/bank/account-admin/index" */))
const _be427fc6 = () => interopDefault(import('../pages/personal/bank/address/index.vue' /* webpackChunkName: "pages/personal/bank/address/index" */))
const _77a346b8 = () => interopDefault(import('../pages/personal/bank/address-us/index.vue' /* webpackChunkName: "pages/personal/bank/address-us/index" */))
const _376818c6 = () => interopDefault(import('../pages/personal/bank/index-type.ts' /* webpackChunkName: "pages/personal/bank/index-type" */))
const _93287d82 = () => interopDefault(import('../pages/personal/common/bank-icon.vue' /* webpackChunkName: "pages/personal/common/bank-icon" */))
const _07712d08 = () => interopDefault(import('../pages/personal/common/binding-icon.vue' /* webpackChunkName: "pages/personal/common/binding-icon" */))
const _a4149bc2 = () => interopDefault(import('../pages/personal/common/input.vue' /* webpackChunkName: "pages/personal/common/input" */))
const _aeaca9b0 = () => interopDefault(import('../pages/personal/common/paypal-icon.vue' /* webpackChunkName: "pages/personal/common/paypal-icon" */))
const _7ca5d200 = () => interopDefault(import('../pages/personal/payment/list.vue' /* webpackChunkName: "pages/personal/payment/list" */))
const _5e1965f6 = () => interopDefault(import('../pages/personal/payment/record/index.vue' /* webpackChunkName: "pages/personal/payment/record/index" */))
const _fcc62066 = () => interopDefault(import('../pages/personal/paypal/account/index.vue' /* webpackChunkName: "pages/personal/paypal/account/index" */))
const _faf9c266 = () => interopDefault(import('../pages/personal/paypal/change-address/index.vue' /* webpackChunkName: "pages/personal/paypal/change-address/index" */))
const _67afd260 = () => interopDefault(import('../pages/personal/paypal/jp-add/index.vue' /* webpackChunkName: "pages/personal/paypal/jp-add/index" */))
const _fda8defa = () => interopDefault(import('../pages/personal/paypal/jp-bank/index.vue' /* webpackChunkName: "pages/personal/paypal/jp-bank/index" */))
const _64bdf5b4 = () => interopDefault(import('../pages/personal/paypal/jp-binding/index.vue' /* webpackChunkName: "pages/personal/paypal/jp-binding/index" */))
const _69ef2267 = () => interopDefault(import('../pages/personal/paypal/middle-page/index.vue' /* webpackChunkName: "pages/personal/paypal/middle-page/index" */))
const _f6917de2 = () => interopDefault(import('../pages/personal/paypal/paypal-middle/index.vue' /* webpackChunkName: "pages/personal/paypal/paypal-middle/index" */))
const _513ba597 = () => interopDefault(import('../pages/personal/paypal/paypal-result/index.vue' /* webpackChunkName: "pages/personal/paypal/paypal-result/index" */))
const _f9a505e4 = () => interopDefault(import('../pages/personal/paypal/revise-account/index.vue' /* webpackChunkName: "pages/personal/paypal/revise-account/index" */))
const _67821a70 = () => interopDefault(import('../pages/product/info-correction/track-utils.js' /* webpackChunkName: "pages/product/info-correction/track-utils" */))
const _4fb4716c = () => interopDefault(import('../pages/product/info-correction/trackConfig.js' /* webpackChunkName: "pages/product/info-correction/trackConfig" */))
const _19d3e9bc = () => interopDefault(import('../pages/product/publicity/img.ts' /* webpackChunkName: "pages/product/publicity/img" */))
const _2b7c8080 = () => interopDefault(import('../pages/product/publicity/track-utils.js' /* webpackChunkName: "pages/product/publicity/track-utils" */))
const _37635502 = () => interopDefault(import('../pages/product/publicity/trackConfig.js' /* webpackChunkName: "pages/product/publicity/trackConfig" */))
const _e7c7b0c6 = () => interopDefault(import('../pages/seller/preferential-rates-new/index-type.ts' /* webpackChunkName: "pages/seller/preferential-rates-new/index-type" */))
const _00cce1ec = () => interopDefault(import('../pages/seller/preferential-rates/index-type.ts' /* webpackChunkName: "pages/seller/preferential-rates/index-type" */))
const _588e4995 = () => interopDefault(import('../pages/seller/rule/table.vue' /* webpackChunkName: "pages/seller/rule/table" */))
const _1ea7d8fe = () => interopDefault(import('../pages/share/components/new-guest-banner.vue' /* webpackChunkName: "pages/share/components/new-guest-banner" */))
const _de66d33e = () => interopDefault(import('../pages/share/components/new-guest-step.vue' /* webpackChunkName: "pages/share/components/new-guest-step" */))
const _1e6f44cc = () => interopDefault(import('../pages/share/product-detail/trackConfig.js' /* webpackChunkName: "pages/share/product-detail/trackConfig" */))
const _1f11ba83 = () => interopDefault(import('../pages/share/seller-initiate/api.js' /* webpackChunkName: "pages/share/seller-initiate/api" */))
const _5b2388d0 = () => interopDefault(import('../pages/share/seller-initiate/components/index.js' /* webpackChunkName: "pages/share/seller-initiate/components/index" */))
const _01f030e0 = () => interopDefault(import('../pages/activity/lottery-free/components/countdown/index.vue' /* webpackChunkName: "pages/activity/lottery-free/components/countdown/index" */))
const _5271d823 = () => interopDefault(import('../pages/activity/lottery-free/components/image-text.vue' /* webpackChunkName: "pages/activity/lottery-free/components/image-text" */))
const _d757aeb8 = () => interopDefault(import('../pages/activity/lottery-free/components/lottery-yards/index.vue' /* webpackChunkName: "pages/activity/lottery-free/components/lottery-yards/index" */))
const _f09acb44 = () => interopDefault(import('../pages/activity/lottery-free/components/past-lottery-item.vue' /* webpackChunkName: "pages/activity/lottery-free/components/past-lottery-item" */))
const _780ff710 = () => interopDefault(import('../pages/activity/lottery-free/components/product-info.vue' /* webpackChunkName: "pages/activity/lottery-free/components/product-info" */))
const _a7ca2980 = () => interopDefault(import('../pages/activity/lottery-free/components/rule.vue' /* webpackChunkName: "pages/activity/lottery-free/components/rule" */))
const _ec93c570 = () => interopDefault(import('../pages/activity/lottery-free/components/share-success-pop/index.vue' /* webpackChunkName: "pages/activity/lottery-free/components/share-success-pop/index" */))
const _12c57a81 = () => interopDefault(import('../pages/activity/lottery-free/components/tab.vue' /* webpackChunkName: "pages/activity/lottery-free/components/tab" */))
const _71bb983e = () => interopDefault(import('../pages/activity/lottery-free/components/winning-result.vue' /* webpackChunkName: "pages/activity/lottery-free/components/winning-result" */))
const _354172b5 = () => interopDefault(import('../pages/activity/new-user-tasks/components/abnormal-block.vue' /* webpackChunkName: "pages/activity/new-user-tasks/components/abnormal-block" */))
const _0508b414 = () => interopDefault(import('../pages/activity/new-user-tasks/components/details-list.vue' /* webpackChunkName: "pages/activity/new-user-tasks/components/details-list" */))
const _e6953eba = () => interopDefault(import('../pages/activity/new-user-tasks/components/question-icon.vue' /* webpackChunkName: "pages/activity/new-user-tasks/components/question-icon" */))
const _7d123dbc = () => interopDefault(import('../pages/activity/sign/components/RecomGoods/index.vue' /* webpackChunkName: "pages/activity/sign/components/RecomGoods/index" */))
const _2d6c51fc = () => interopDefault(import('../pages/activity/sign/components/RecordSlide/index.vue' /* webpackChunkName: "pages/activity/sign/components/RecordSlide/index" */))
const _748209e0 = () => interopDefault(import('../pages/activity/sign/components/sign-record.vue' /* webpackChunkName: "pages/activity/sign/components/sign-record" */))
const _e02a3cce = () => interopDefault(import('../pages/activity/sign/rewardRecord/trackConfig.js' /* webpackChunkName: "pages/activity/sign/rewardRecord/trackConfig" */))
const _97be1db8 = () => interopDefault(import('../pages/help/category/components/feedback-bubble.vue' /* webpackChunkName: "pages/help/category/components/feedback-bubble" */))
const _5559644e = () => interopDefault(import('../pages/help/survey/components/result.vue' /* webpackChunkName: "pages/help/survey/components/result" */))
const _4b4950ea = () => interopDefault(import('../pages/other/supplementary/components/jp.vue' /* webpackChunkName: "pages/other/supplementary/components/jp" */))
const _4d1a588b = () => interopDefault(import('../pages/other/supplementary/components/kr.vue' /* webpackChunkName: "pages/other/supplementary/components/kr" */))
const _5e38e642 = () => interopDefault(import('../pages/other/supplementary/components/us.vue' /* webpackChunkName: "pages/other/supplementary/components/us" */))
const _66261ed2 = () => interopDefault(import('../pages/other/supplementary/components/zh.vue' /* webpackChunkName: "pages/other/supplementary/components/zh" */))
const _241ee62c = () => interopDefault(import('../pages/payment/airwallex/fastPay/trackConfig.js' /* webpackChunkName: "pages/payment/airwallex/fastPay/trackConfig" */))
const _1a090830 = () => interopDefault(import('../pages/payment/airwallex/pay/trackConfig.js' /* webpackChunkName: "pages/payment/airwallex/pay/trackConfig" */))
const _2bbf2e6d = () => interopDefault(import('../pages/personal/bank/address-us/tip.vue' /* webpackChunkName: "pages/personal/bank/address-us/tip" */))
const _1d3c913c = () => interopDefault(import('../pages/personal/bank/address-us/utils.ts' /* webpackChunkName: "pages/personal/bank/address-us/utils" */))
const _7c17c7b4 = () => interopDefault(import('../pages/personal/bank/address/tip.vue' /* webpackChunkName: "pages/personal/bank/address/tip" */))
const _21ca80c9 = () => interopDefault(import('../pages/personal/bank/address/utils.ts' /* webpackChunkName: "pages/personal/bank/address/utils" */))
const _c8b93ac8 = () => interopDefault(import('../pages/personal/bank/components/account-type/index.vue' /* webpackChunkName: "pages/personal/bank/components/account-type/index" */))
const _2cfc58b2 = () => interopDefault(import('../pages/personal/bank/components/bank-code/index.vue' /* webpackChunkName: "pages/personal/bank/components/bank-code/index" */))
const _0b4e597b = () => interopDefault(import('../pages/personal/paypal/account/component/index.vue' /* webpackChunkName: "pages/personal/paypal/account/component/index" */))
const _5aed12ea = () => interopDefault(import('../pages/personal/paypal/jp-add/components/index.vue' /* webpackChunkName: "pages/personal/paypal/jp-add/components/index" */))
const _248cd542 = () => interopDefault(import('../pages/product/info-correction/components/active-icon.vue' /* webpackChunkName: "pages/product/info-correction/components/active-icon" */))
const _5f234c0e = () => interopDefault(import('../pages/product/info-correction/components/failed.vue' /* webpackChunkName: "pages/product/info-correction/components/failed" */))
const _035ac84c = () => interopDefault(import('../pages/product/info-correction/components/inactive-icon.vue' /* webpackChunkName: "pages/product/info-correction/components/inactive-icon" */))
const _16da360f = () => interopDefault(import('../pages/product/info-correction/components/other-block.vue' /* webpackChunkName: "pages/product/info-correction/components/other-block" */))
const _275f4482 = () => interopDefault(import('../pages/product/info-correction/components/success.vue' /* webpackChunkName: "pages/product/info-correction/components/success" */))
const _0bc8e385 = () => interopDefault(import('../pages/product/publicity/components/notice-icon.vue' /* webpackChunkName: "pages/product/publicity/components/notice-icon" */))
const _05e6e17c = () => interopDefault(import('../pages/seller/preferential-rates-new/components/banner.vue' /* webpackChunkName: "pages/seller/preferential-rates-new/components/banner" */))
const _382aa25a = () => interopDefault(import('../pages/seller/preferential-rates-new/components/main-title.vue' /* webpackChunkName: "pages/seller/preferential-rates-new/components/main-title" */))
const _665861e7 = () => interopDefault(import('../pages/seller/preferential-rates-new/components/record.vue' /* webpackChunkName: "pages/seller/preferential-rates-new/components/record" */))
const _f971f2dc = () => interopDefault(import('../pages/seller/preferential-rates-new/components/rule.vue' /* webpackChunkName: "pages/seller/preferential-rates-new/components/rule" */))
const _65688a16 = () => interopDefault(import('../pages/seller/preferential-rates-new/components/tip.vue' /* webpackChunkName: "pages/seller/preferential-rates-new/components/tip" */))
const _4d5639af = () => interopDefault(import('../pages/seller/preferential-rates/components/banner.vue' /* webpackChunkName: "pages/seller/preferential-rates/components/banner" */))
const _c4e16372 = () => interopDefault(import('../pages/seller/preferential-rates/components/main-title.vue' /* webpackChunkName: "pages/seller/preferential-rates/components/main-title" */))
const _92bbe758 = () => interopDefault(import('../pages/seller/preferential-rates/components/record.vue' /* webpackChunkName: "pages/seller/preferential-rates/components/record" */))
const _663b2f82 = () => interopDefault(import('../pages/seller/preferential-rates/components/rule.vue' /* webpackChunkName: "pages/seller/preferential-rates/components/rule" */))
const _7d16efa8 = () => interopDefault(import('../pages/seller/preferential-rates/components/tip.vue' /* webpackChunkName: "pages/seller/preferential-rates/components/tip" */))
const _9a738ab2 = () => interopDefault(import('../pages/seller/preferential-rates/components/v-progress.vue' /* webpackChunkName: "pages/seller/preferential-rates/components/v-progress" */))
const _6a75e424 = () => interopDefault(import('../pages/share/product-detail/components/image-text.vue' /* webpackChunkName: "pages/share/product-detail/components/image-text" */))
const _35c68734 = () => interopDefault(import('../pages/share/product-detail/components/recent-purchase.vue' /* webpackChunkName: "pages/share/product-detail/components/recent-purchase" */))
const _2e21d68e = () => interopDefault(import('../pages/share/seller-initiate/components/activity-information.vue' /* webpackChunkName: "pages/share/seller-initiate/components/activity-information" */))
const _799af4b4 = () => interopDefault(import('../pages/share/seller-initiate/components/deal-info.vue' /* webpackChunkName: "pages/share/seller-initiate/components/deal-info" */))
const _4d2f3da4 = () => interopDefault(import('../pages/share/seller-initiate/components/share.vue' /* webpackChunkName: "pages/share/seller-initiate/components/share" */))
const _5f328bda = () => interopDefault(import('../pages/activity/lottery-free/components/countdown/drawTime.vue' /* webpackChunkName: "pages/activity/lottery-free/components/countdown/drawTime" */))
const _7fc93e46 = () => interopDefault(import('../pages/activity/lottery-free/components/countdown/startTime.vue' /* webpackChunkName: "pages/activity/lottery-free/components/countdown/startTime" */))
const _372a1b50 = () => interopDefault(import('../pages/activity/sign/components/RecomGoods/trackConfig.js' /* webpackChunkName: "pages/activity/sign/components/RecomGoods/trackConfig" */))
const _0f7e34d2 = () => interopDefault(import('../pages/activity/sign/components/RecordSlide/trackConfig.js' /* webpackChunkName: "pages/activity/sign/components/RecordSlide/trackConfig" */))
const _72a09587 = () => interopDefault(import('../pages/personal/paypal/jp-bank/components/failed.vue' /* webpackChunkName: "pages/personal/paypal/jp-bank/components/failed" */))
const _7d5cf23c = () => interopDefault(import('../pages/personal/paypal/jp-bank/components/loading.vue' /* webpackChunkName: "pages/personal/paypal/jp-bank/components/loading" */))
const _f8e9abae = () => interopDefault(import('../pages/personal/paypal/jp-bank/components/success.vue' /* webpackChunkName: "pages/personal/paypal/jp-bank/components/success" */))
const _d7ce157c = () => interopDefault(import('../pages/personal/paypal/revise-account/components/Steps.vue' /* webpackChunkName: "pages/personal/paypal/revise-account/components/Steps" */))
const _6df53a5c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/overseas/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/delivery-guide",
    component: _1c00110c,
    name: "delivery-guide"
  }, {
    path: "/drop-off",
    component: _5449dfba,
    name: "drop-off"
  }, {
    path: "/faq",
    component: _1f5244ba,
    name: "faq"
  }, {
    path: "/fullfillment-rate",
    component: _4940d5ea,
    name: "fullfillment-rate"
  }, {
    path: "/grade-rights",
    component: _7c7b8e94,
    name: "grade-rights"
  }, {
    path: "/preview-picture",
    component: _cbb65874,
    name: "preview-picture"
  }, {
    path: "/activity/bid-application",
    component: _6fbe14e9,
    name: "activity-bid-application"
  }, {
    path: "/activity/demo-bid-application",
    component: _d81e60ba,
    name: "activity-demo-bid-application"
  }, {
    path: "/activity/new-user-tasks",
    component: _46ec5bb4,
    name: "activity-new-user-tasks"
  }, {
    path: "/activity/sign",
    component: _5648f40a,
    name: "activity-sign"
  }, {
    path: "/automatic-distribution/landing",
    component: _241b4f57,
    name: "automatic-distribution-landing"
  }, {
    path: "/automatic-distribution/tip",
    component: _767abb5b,
    name: "automatic-distribution-tip"
  }, {
    path: "/consignment/apply",
    component: _816a72ee,
    name: "consignment-apply"
  }, {
    path: "/consignment/explain",
    component: _5b6010d2,
    name: "consignment-explain"
  }, {
    path: "/consignment/krTerminal",
    component: _55db8ede,
    name: "consignment-krTerminal"
  }, {
    path: "/consignment/pickUp",
    component: _83488592,
    name: "consignment-pickUp"
  }, {
    path: "/consignment/usTerminal",
    component: _2fd85055,
    name: "consignment-usTerminal"
  }, {
    path: "/drop-off/api",
    component: _794d9783,
    name: "drop-off-api"
  }, {
    path: "/email/api",
    component: _418a2918,
    name: "email-api"
  }, {
    path: "/email/apply-on",
    component: _4bc7bd5a,
    name: "email-apply-on"
  }, {
    path: "/email/deal-guide",
    component: _6bc5b2d2,
    name: "email-deal-guide"
  }, {
    path: "/email/product-list",
    component: _57643ab5,
    name: "email-product-list"
  }, {
    path: "/email/trackConfig",
    component: _5295b20b,
    name: "email-trackConfig"
  }, {
    path: "/email/welcome",
    component: _666f18bc,
    name: "email-welcome"
  }, {
    path: "/faq/api",
    component: _32d2eb8c,
    name: "faq-api"
  }, {
    path: "/faq/detail",
    component: _9a503360,
    name: "faq-detail"
  }, {
    path: "/faq/lang",
    component: _18e5eec2,
    name: "faq-lang"
  }, {
    path: "/faq/started",
    component: _eb84a6d6,
    name: "faq-started"
  }, {
    path: "/fullfillment-rate/api",
    component: _04b5cf53,
    name: "fullfillment-rate-api"
  }, {
    path: "/fullfillment-rate/trackConfig",
    component: _341a46ea,
    name: "fullfillment-rate-trackConfig"
  }, {
    path: "/fullfillment-rate/types",
    component: _4f454094,
    name: "fullfillment-rate-types"
  }, {
    path: "/help/api",
    component: _1827665a,
    name: "help-api"
  }, {
    path: "/help/category",
    component: _009e7899,
    name: "help-category"
  }, {
    path: "/help/channel",
    component: _696e825e,
    name: "help-channel"
  }, {
    path: "/help/constants",
    component: _f27b2504,
    name: "help-constants"
  }, {
    path: "/help/detail",
    component: _4466efa8,
    name: "help-detail"
  }, {
    path: "/help/search",
    component: _b24d567a,
    name: "help-search"
  }, {
    path: "/help/survey",
    component: _1e2cc016,
    name: "help-survey"
  }, {
    path: "/identify/add-picture-example",
    component: _6e7bcb52,
    name: "identify-add-picture-example"
  }, {
    path: "/identify/app",
    component: _714dfb87,
    name: "identify-app"
  }, {
    path: "/identify/app-detail",
    component: _c9ee2326,
    name: "identify-app-detail"
  }, {
    path: "/identify/certificate",
    component: _1872ac7d,
    name: "identify-certificate"
  }, {
    path: "/identify/guide",
    component: _42ddefe2,
    name: "identify-guide"
  }, {
    path: "/identify/result",
    component: _a686a0e6,
    name: "identify-result"
  }, {
    path: "/jockey/demo",
    component: _498e4ddb,
    name: "jockey-demo"
  }, {
    path: "/newUser/clothes",
    component: _0eec7dd1,
    name: "newUser-clothes"
  }, {
    path: "/newUser/shoes",
    component: _7e21aff1,
    name: "newUser-shoes"
  }, {
    path: "/newUser/watch",
    component: _285205d0,
    name: "newUser-watch"
  }, {
    path: "/notice/seller-detail",
    component: _30284864,
    name: "notice-seller-detail"
  }, {
    path: "/other/api",
    component: _0aa3ad80,
    name: "other-api"
  }, {
    path: "/other/authentication-rules",
    component: _0d5504ac,
    name: "other-authentication-rules"
  }, {
    path: "/other/conditions-of-use",
    component: _5bef7758,
    name: "other-conditions-of-use"
  }, {
    path: "/other/payment",
    component: _c4ef1e58,
    name: "other-payment"
  }, {
    path: "/other/privacy-policy",
    component: _762102df,
    name: "other-privacy-policy"
  }, {
    path: "/other/protocol",
    component: _7a9b56e0,
    name: "other-protocol"
  }, {
    path: "/other/supplementary",
    component: _2a0adf46,
    name: "other-supplementary"
  }, {
    path: "/other/user-protocol",
    component: _50fca430,
    name: "other-user-protocol"
  }, {
    path: "/payment/result",
    component: _55b8d1af,
    name: "payment-result"
  }, {
    path: "/personal/bank",
    component: _78e4ae78,
    name: "personal-bank"
  }, {
    path: "/personal/config",
    component: _6ed3aa98,
    name: "personal-config"
  }, {
    path: "/personal/mixins",
    component: _3a6437e4,
    name: "personal-mixins"
  }, {
    path: "/personal/track-utils",
    component: _59f35bee,
    name: "personal-track-utils"
  }, {
    path: "/personal/trackConfig",
    component: _4225b2ea,
    name: "personal-trackConfig"
  }, {
    path: "/product/info-correction",
    component: _015e998a,
    name: "product-info-correction"
  }, {
    path: "/product/publicity",
    component: _595d58d2,
    name: "product-publicity"
  }, {
    path: "/seller/preferential-rates",
    component: _27b3e6bc,
    name: "seller-preferential-rates"
  }, {
    path: "/seller/preferential-rates-new",
    component: _64a7c0cf,
    name: "seller-preferential-rates-new"
  }, {
    path: "/seller/rule",
    component: _c219d6ce,
    name: "seller-rule"
  }, {
    path: "/share/activity",
    component: _2b534d30,
    name: "share-activity"
  }, {
    path: "/share/api",
    component: _7c8bb45e,
    name: "share-api"
  }, {
    path: "/share/components",
    component: _79e60f00,
    name: "share-components"
  }, {
    path: "/share/download-app",
    component: _40230572,
    name: "share-download-app"
  }, {
    path: "/share/product-detail",
    component: _6e9932c8,
    name: "share-product-detail"
  }, {
    path: "/share/product-sales",
    component: _b1c0adea,
    name: "share-product-sales"
  }, {
    path: "/share/rate-activity",
    component: _7038d239,
    name: "share-rate-activity"
  }, {
    path: "/share/seller-initiate",
    component: _8f087078,
    name: "share-seller-initiate"
  }, {
    path: "/share/seller-invited",
    component: _66129886,
    name: "share-seller-invited"
  }, {
    path: "/share/venue",
    component: _45057d8c,
    name: "share-venue"
  }, {
    path: "/activity/lottery-free/address",
    component: _fe1a78bc,
    name: "activity-lottery-free-address"
  }, {
    path: "/activity/lottery-free/components",
    component: _f542f0de,
    name: "activity-lottery-free-components"
  }, {
    path: "/activity/lottery-free/current",
    component: _756282e7,
    name: "activity-lottery-free-current"
  }, {
    path: "/activity/lottery-free/detail",
    component: _457fee39,
    name: "activity-lottery-free-detail"
  }, {
    path: "/activity/lottery-free/past",
    component: _39d5dbfa,
    name: "activity-lottery-free-past"
  }, {
    path: "/activity/lottery-free/share-detail",
    component: _52bb80a7,
    name: "activity-lottery-free-share-detail"
  }, {
    path: "/activity/lottery-free/track-utils",
    component: _51581596,
    name: "activity-lottery-free-track-utils"
  }, {
    path: "/activity/lottery-free/trackConfig",
    component: _398a6c92,
    name: "activity-lottery-free-trackConfig"
  }, {
    path: "/activity/new-user-tasks/track-utils",
    component: _64ea88a8,
    name: "activity-new-user-tasks-track-utils"
  }, {
    path: "/activity/new-user-tasks/trackConfig",
    component: _4d1cdfa4,
    name: "activity-new-user-tasks-trackConfig"
  }, {
    path: "/activity/sign/api",
    component: _3d2f6533,
    name: "activity-sign-api"
  }, {
    path: "/activity/sign/components",
    component: _63281dde,
    name: "activity-sign-components"
  }, {
    path: "/activity/sign/rewardRecord",
    component: _db8fec4a,
    name: "activity-sign-rewardRecord"
  }, {
    path: "/activity/sign/track-utils",
    component: _68292848,
    name: "activity-sign-track-utils"
  }, {
    path: "/activity/sign/trackConfig",
    component: _740ffcca,
    name: "activity-sign-trackConfig"
  }, {
    path: "/automatic-distribution/landing/trackConfig",
    component: _45e3a99d,
    name: "automatic-distribution-landing-trackConfig"
  }, {
    path: "/automatic-distribution/tip/trackConfig",
    component: _2dc9bfce,
    name: "automatic-distribution-tip-trackConfig"
  }, {
    path: "/consignment/apply/trackConfig",
    component: _93ce3caa,
    name: "consignment-apply-trackConfig"
  }, {
    path: "/consignment/explain/guide",
    component: _3cfb177f,
    name: "consignment-explain-guide"
  }, {
    path: "/consignment/explain/rule",
    component: _20b674a2,
    name: "consignment-explain-rule"
  }, {
    path: "/email/welcome/trackConfig",
    component: _29def758,
    name: "email-welcome-trackConfig"
  }, {
    path: "/faq/components/collapse",
    component: _6d4584d2,
    name: "faq-components-collapse"
  }, {
    path: "/faq/started/index-abord",
    component: _b0621f30,
    name: "faq-started-index-abord"
  }, {
    path: "/help/category/mock",
    component: _e556995c,
    name: "help-category-mock"
  }, {
    path: "/help/category/types",
    component: _1b610c05,
    name: "help-category-types"
  }, {
    path: "/help/config/surveyTrackConfig",
    component: _1bc8a772,
    name: "help-config-surveyTrackConfig"
  }, {
    path: "/help/detail/trackConfig",
    component: _24a4a430,
    name: "help-detail-trackConfig"
  }, {
    path: "/help/search/trackConfig",
    component: _0a6c27b1,
    name: "help-search-trackConfig"
  }, {
    path: "/identify/app-detail/filter",
    component: _d29b30fc,
    name: "identify-app-detail-filter"
  }, {
    path: "/identify/certificate/trackConfig",
    component: _63769437,
    name: "identify-certificate-trackConfig"
  }, {
    path: "/identify/result/img",
    component: _8644b372,
    name: "identify-result-img"
  }, {
    path: "/identify/result/trackConfig",
    component: _2743fb27,
    name: "identify-result-trackConfig"
  }, {
    path: "/newUser/clothes/config",
    component: _0f2bb2dc,
    name: "newUser-clothes-config"
  }, {
    path: "/newUser/components/imgBlock",
    component: _4414d869,
    name: "newUser-components-imgBlock"
  }, {
    path: "/newUser/shoes/config",
    component: _7e60e4fc,
    name: "newUser-shoes-config"
  }, {
    path: "/newUser/watch/config",
    component: _27d39bba,
    name: "newUser-watch-config"
  }, {
    path: "/other/authentication-rules/lg-json",
    component: _9b05d306,
    name: "other-authentication-rules-lg-json"
  }, {
    path: "/other/conditions-of-use/lg-json",
    component: _1fb9b5da,
    name: "other-conditions-of-use-lg-json"
  }, {
    path: "/other/privacy-policy/lg-json",
    component: _61bb9030,
    name: "other-privacy-policy-lg-json"
  }, {
    path: "/other/protocol/protocal-handle",
    component: _6e4532f2,
    name: "other-protocol-protocal-handle"
  }, {
    path: "/payment/airwallex/api",
    component: _8b86aa5c,
    name: "payment-airwallex-api"
  }, {
    path: "/payment/airwallex/fastPay",
    component: _b57b9530,
    name: "payment-airwallex-fastPay"
  }, {
    path: "/payment/airwallex/pay",
    component: _0843e0e4,
    name: "payment-airwallex-pay"
  }, {
    path: "/payment/airwallex/util",
    component: _93784868,
    name: "payment-airwallex-util"
  }, {
    path: "/personal/bank/account-admin",
    component: _16ec3f98,
    name: "personal-bank-account-admin"
  }, {
    path: "/personal/bank/address",
    component: _be427fc6,
    name: "personal-bank-address"
  }, {
    path: "/personal/bank/address-us",
    component: _77a346b8,
    name: "personal-bank-address-us"
  }, {
    path: "/personal/bank/index-type",
    component: _376818c6,
    name: "personal-bank-index-type"
  }, {
    path: "/personal/common/bank-icon",
    component: _93287d82,
    name: "personal-common-bank-icon"
  }, {
    path: "/personal/common/binding-icon",
    component: _07712d08,
    name: "personal-common-binding-icon"
  }, {
    path: "/personal/common/input",
    component: _a4149bc2,
    name: "personal-common-input"
  }, {
    path: "/personal/common/paypal-icon",
    component: _aeaca9b0,
    name: "personal-common-paypal-icon"
  }, {
    path: "/personal/payment/list",
    component: _7ca5d200,
    name: "personal-payment-list"
  }, {
    path: "/personal/payment/record",
    component: _5e1965f6,
    name: "personal-payment-record"
  }, {
    path: "/personal/paypal/account",
    component: _fcc62066,
    name: "personal-paypal-account"
  }, {
    path: "/personal/paypal/change-address",
    component: _faf9c266,
    name: "personal-paypal-change-address"
  }, {
    path: "/personal/paypal/jp-add",
    component: _67afd260,
    name: "personal-paypal-jp-add"
  }, {
    path: "/personal/paypal/jp-bank",
    component: _fda8defa,
    name: "personal-paypal-jp-bank"
  }, {
    path: "/personal/paypal/jp-binding",
    component: _64bdf5b4,
    name: "personal-paypal-jp-binding"
  }, {
    path: "/personal/paypal/middle-page",
    component: _69ef2267,
    name: "personal-paypal-middle-page"
  }, {
    path: "/personal/paypal/paypal-middle",
    component: _f6917de2,
    name: "personal-paypal-paypal-middle"
  }, {
    path: "/personal/paypal/paypal-result",
    component: _513ba597,
    name: "personal-paypal-paypal-result"
  }, {
    path: "/personal/paypal/revise-account",
    component: _f9a505e4,
    name: "personal-paypal-revise-account"
  }, {
    path: "/product/info-correction/track-utils",
    component: _67821a70,
    name: "product-info-correction-track-utils"
  }, {
    path: "/product/info-correction/trackConfig",
    component: _4fb4716c,
    name: "product-info-correction-trackConfig"
  }, {
    path: "/product/publicity/img",
    component: _19d3e9bc,
    name: "product-publicity-img"
  }, {
    path: "/product/publicity/track-utils",
    component: _2b7c8080,
    name: "product-publicity-track-utils"
  }, {
    path: "/product/publicity/trackConfig",
    component: _37635502,
    name: "product-publicity-trackConfig"
  }, {
    path: "/seller/preferential-rates-new/index-type",
    component: _e7c7b0c6,
    name: "seller-preferential-rates-new-index-type"
  }, {
    path: "/seller/preferential-rates/index-type",
    component: _00cce1ec,
    name: "seller-preferential-rates-index-type"
  }, {
    path: "/seller/rule/table",
    component: _588e4995,
    name: "seller-rule-table"
  }, {
    path: "/share/components/new-guest-banner",
    component: _1ea7d8fe,
    name: "share-components-new-guest-banner"
  }, {
    path: "/share/components/new-guest-step",
    component: _de66d33e,
    name: "share-components-new-guest-step"
  }, {
    path: "/share/product-detail/trackConfig",
    component: _1e6f44cc,
    name: "share-product-detail-trackConfig"
  }, {
    path: "/share/seller-initiate/api",
    component: _1f11ba83,
    name: "share-seller-initiate-api"
  }, {
    path: "/share/seller-initiate/components",
    component: _5b2388d0,
    name: "share-seller-initiate-components"
  }, {
    path: "/activity/lottery-free/components/countdown",
    component: _01f030e0,
    name: "activity-lottery-free-components-countdown"
  }, {
    path: "/activity/lottery-free/components/image-text",
    component: _5271d823,
    name: "activity-lottery-free-components-image-text"
  }, {
    path: "/activity/lottery-free/components/lottery-yards",
    component: _d757aeb8,
    name: "activity-lottery-free-components-lottery-yards"
  }, {
    path: "/activity/lottery-free/components/past-lottery-item",
    component: _f09acb44,
    name: "activity-lottery-free-components-past-lottery-item"
  }, {
    path: "/activity/lottery-free/components/product-info",
    component: _780ff710,
    name: "activity-lottery-free-components-product-info"
  }, {
    path: "/activity/lottery-free/components/rule",
    component: _a7ca2980,
    name: "activity-lottery-free-components-rule"
  }, {
    path: "/activity/lottery-free/components/share-success-pop",
    component: _ec93c570,
    name: "activity-lottery-free-components-share-success-pop"
  }, {
    path: "/activity/lottery-free/components/tab",
    component: _12c57a81,
    name: "activity-lottery-free-components-tab"
  }, {
    path: "/activity/lottery-free/components/winning-result",
    component: _71bb983e,
    name: "activity-lottery-free-components-winning-result"
  }, {
    path: "/activity/new-user-tasks/components/abnormal-block",
    component: _354172b5,
    name: "activity-new-user-tasks-components-abnormal-block"
  }, {
    path: "/activity/new-user-tasks/components/details-list",
    component: _0508b414,
    name: "activity-new-user-tasks-components-details-list"
  }, {
    path: "/activity/new-user-tasks/components/question-icon",
    component: _e6953eba,
    name: "activity-new-user-tasks-components-question-icon"
  }, {
    path: "/activity/sign/components/RecomGoods",
    component: _7d123dbc,
    name: "activity-sign-components-RecomGoods"
  }, {
    path: "/activity/sign/components/RecordSlide",
    component: _2d6c51fc,
    name: "activity-sign-components-RecordSlide"
  }, {
    path: "/activity/sign/components/sign-record",
    component: _748209e0,
    name: "activity-sign-components-sign-record"
  }, {
    path: "/activity/sign/rewardRecord/trackConfig",
    component: _e02a3cce,
    name: "activity-sign-rewardRecord-trackConfig"
  }, {
    path: "/help/category/components/feedback-bubble",
    component: _97be1db8,
    name: "help-category-components-feedback-bubble"
  }, {
    path: "/help/survey/components/result",
    component: _5559644e,
    name: "help-survey-components-result"
  }, {
    path: "/other/supplementary/components/jp",
    component: _4b4950ea,
    name: "other-supplementary-components-jp"
  }, {
    path: "/other/supplementary/components/kr",
    component: _4d1a588b,
    name: "other-supplementary-components-kr"
  }, {
    path: "/other/supplementary/components/us",
    component: _5e38e642,
    name: "other-supplementary-components-us"
  }, {
    path: "/other/supplementary/components/zh",
    component: _66261ed2,
    name: "other-supplementary-components-zh"
  }, {
    path: "/payment/airwallex/fastPay/trackConfig",
    component: _241ee62c,
    name: "payment-airwallex-fastPay-trackConfig"
  }, {
    path: "/payment/airwallex/pay/trackConfig",
    component: _1a090830,
    name: "payment-airwallex-pay-trackConfig"
  }, {
    path: "/personal/bank/address-us/tip",
    component: _2bbf2e6d,
    name: "personal-bank-address-us-tip"
  }, {
    path: "/personal/bank/address-us/utils",
    component: _1d3c913c,
    name: "personal-bank-address-us-utils"
  }, {
    path: "/personal/bank/address/tip",
    component: _7c17c7b4,
    name: "personal-bank-address-tip"
  }, {
    path: "/personal/bank/address/utils",
    component: _21ca80c9,
    name: "personal-bank-address-utils"
  }, {
    path: "/personal/bank/components/account-type",
    component: _c8b93ac8,
    name: "personal-bank-components-account-type"
  }, {
    path: "/personal/bank/components/bank-code",
    component: _2cfc58b2,
    name: "personal-bank-components-bank-code"
  }, {
    path: "/personal/paypal/account/component",
    component: _0b4e597b,
    name: "personal-paypal-account-component"
  }, {
    path: "/personal/paypal/jp-add/components",
    component: _5aed12ea,
    name: "personal-paypal-jp-add-components"
  }, {
    path: "/product/info-correction/components/active-icon",
    component: _248cd542,
    name: "product-info-correction-components-active-icon"
  }, {
    path: "/product/info-correction/components/failed",
    component: _5f234c0e,
    name: "product-info-correction-components-failed"
  }, {
    path: "/product/info-correction/components/inactive-icon",
    component: _035ac84c,
    name: "product-info-correction-components-inactive-icon"
  }, {
    path: "/product/info-correction/components/other-block",
    component: _16da360f,
    name: "product-info-correction-components-other-block"
  }, {
    path: "/product/info-correction/components/success",
    component: _275f4482,
    name: "product-info-correction-components-success"
  }, {
    path: "/product/publicity/components/notice-icon",
    component: _0bc8e385,
    name: "product-publicity-components-notice-icon"
  }, {
    path: "/seller/preferential-rates-new/components/banner",
    component: _05e6e17c,
    name: "seller-preferential-rates-new-components-banner"
  }, {
    path: "/seller/preferential-rates-new/components/main-title",
    component: _382aa25a,
    name: "seller-preferential-rates-new-components-main-title"
  }, {
    path: "/seller/preferential-rates-new/components/record",
    component: _665861e7,
    name: "seller-preferential-rates-new-components-record"
  }, {
    path: "/seller/preferential-rates-new/components/rule",
    component: _f971f2dc,
    name: "seller-preferential-rates-new-components-rule"
  }, {
    path: "/seller/preferential-rates-new/components/tip",
    component: _65688a16,
    name: "seller-preferential-rates-new-components-tip"
  }, {
    path: "/seller/preferential-rates/components/banner",
    component: _4d5639af,
    name: "seller-preferential-rates-components-banner"
  }, {
    path: "/seller/preferential-rates/components/main-title",
    component: _c4e16372,
    name: "seller-preferential-rates-components-main-title"
  }, {
    path: "/seller/preferential-rates/components/record",
    component: _92bbe758,
    name: "seller-preferential-rates-components-record"
  }, {
    path: "/seller/preferential-rates/components/rule",
    component: _663b2f82,
    name: "seller-preferential-rates-components-rule"
  }, {
    path: "/seller/preferential-rates/components/tip",
    component: _7d16efa8,
    name: "seller-preferential-rates-components-tip"
  }, {
    path: "/seller/preferential-rates/components/v-progress",
    component: _9a738ab2,
    name: "seller-preferential-rates-components-v-progress"
  }, {
    path: "/share/product-detail/components/image-text",
    component: _6a75e424,
    name: "share-product-detail-components-image-text"
  }, {
    path: "/share/product-detail/components/recent-purchase",
    component: _35c68734,
    name: "share-product-detail-components-recent-purchase"
  }, {
    path: "/share/seller-initiate/components/activity-information",
    component: _2e21d68e,
    name: "share-seller-initiate-components-activity-information"
  }, {
    path: "/share/seller-initiate/components/deal-info",
    component: _799af4b4,
    name: "share-seller-initiate-components-deal-info"
  }, {
    path: "/share/seller-initiate/components/share",
    component: _4d2f3da4,
    name: "share-seller-initiate-components-share"
  }, {
    path: "/activity/lottery-free/components/countdown/drawTime",
    component: _5f328bda,
    name: "activity-lottery-free-components-countdown-drawTime"
  }, {
    path: "/activity/lottery-free/components/countdown/startTime",
    component: _7fc93e46,
    name: "activity-lottery-free-components-countdown-startTime"
  }, {
    path: "/activity/sign/components/RecomGoods/trackConfig",
    component: _372a1b50,
    name: "activity-sign-components-RecomGoods-trackConfig"
  }, {
    path: "/activity/sign/components/RecordSlide/trackConfig",
    component: _0f7e34d2,
    name: "activity-sign-components-RecordSlide-trackConfig"
  }, {
    path: "/personal/paypal/jp-bank/components/failed",
    component: _72a09587,
    name: "personal-paypal-jp-bank-components-failed"
  }, {
    path: "/personal/paypal/jp-bank/components/loading",
    component: _7d5cf23c,
    name: "personal-paypal-jp-bank-components-loading"
  }, {
    path: "/personal/paypal/jp-bank/components/success",
    component: _f8e9abae,
    name: "personal-paypal-jp-bank-components-success"
  }, {
    path: "/personal/paypal/revise-account/components/Steps",
    component: _d7ce157c,
    name: "personal-paypal-revise-account-components-Steps"
  }, {
    path: "/",
    component: _6df53a5c,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
